import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BookingCompletedCriteoComponent } from './booking-completed-criteo.component';

@NgModule({
  declarations: [BookingCompletedCriteoComponent],
  imports: [CommonModule],
  exports: [BookingCompletedCriteoComponent],
})
export class BookingCompletedCriteoModule {}
